import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { grayDark, grayMain } from 'crehana-ui/styles/colors';
import T from 'aegisv2/Text';
import IconButton from 'aegisv2/Buttons/IconButton';
import ArrowLeft from 'crehana-icons/ArrowLeft';
import ArrowRight from 'crehana-icons/ArrowRight';
import StepForwards from 'crehana-icons/StepForwards';
import StepBackwards from 'crehana-icons/StepBackwards';
import Flex from 'Shared/ui/Flex';

const Button = styled(IconButton)`
  ${props => props.m && `margin: ${props.m};`};
`;

const Label = styled(T)`
  font-size: 11px !important;
  line-height: 16px !important;
  letter-spacing: 0.8px !important;
  text-transform: uppercase;
`;

const StyledFlex = styled(Flex)`
  flex-shrink: 0;
`;

class Pagination extends Component {
  componentDidMount() {
    this.menuElement = document.querySelector('#MainMenuComponent');
  }

  getHeightMenu = () => {
    if (!this.menuElement) return 72;
    const { height } = this.menuElement.getBoundingClientRect();

    return height;
  };

  scrollTop = () => {
    if (typeof document !== 'undefined') {
      const scrollComponent = document.querySelector('#scroll-to');

      if (scrollComponent) {
        const scrollTop = scrollComponent.offsetTop - this.getHeightMenu();

        if (window.scrollY > scrollTop) {
          window.scroll({ top: scrollTop, left: 0, behavior: 'smooth' });
        }
      }
    }
  };

  goFirst = () => {
    this.scrollTop();
    this.props.onPageChange(1);
  };
  goLast = () => {
    this.scrollTop();
    this.props.onPageChange(this.props.totalPages);
  };
  goPage = diff => {
    const { onPageChange, currentPage } = this.props;

    onPageChange(currentPage + diff);
  };
  goNext = () => {
    this.scrollTop();
    this.goPage(1);
  };
  goBack = () => {
    this.scrollTop();
    this.goPage(-1);
  };

  render() {
    const { className, currentPage, totalPages, loading, dark } = this.props;

    const disabledGoBack = loading || currentPage === 1;
    const disabledGoNext =
      loading || (totalPages === currentPage && totalPages);
    let label = `${currentPage} De ${loading ? '...' : totalPages}`;

    if (!totalPages) {
      label = '...';
    }

    return (
      <StyledFlex a="center" j="center" className={className}>
        <Button onClick={this.goFirst} disabled={disabledGoBack} white={dark}>
          <StepBackwards size={8} />
        </Button>
        <Button
          m="0 8px"
          onClick={this.goBack}
          disabled={disabledGoBack}
          white={dark}
        >
          <ArrowLeft size={8} />
        </Button>
        <Label bold color={dark ? grayMain : grayDark}>
          {label}
        </Label>
        <Button
          m="0 8px"
          onClick={this.goNext}
          disabled={disabledGoNext}
          white={dark}
        >
          <ArrowRight size={8} />
        </Button>
        <Button onClick={this.goLast} disabled={disabledGoNext} white={dark}>
          <StepForwards size={8} />
        </Button>
      </StyledFlex>
    );
  }
}

Pagination.propTypes = {
  className: PropTypes.string,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  dark: PropTypes.bool,
};

Pagination.defaultProps = {
  loading: false,
  className: null,
  totalPages: 1,
  currentPage: 1,
  dark: false,
};

export default Pagination;
